import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon';

export function BoolRenderer(props) {
  const {
    cellData,
    trueIcon = 'check-circle',
    trueIconStyle = 'fas',
    falseIcon = 'circle',
    falseIconStyle = 'far',
  } = props;
  return (
    <span className="bool-column">
      <Icon icon={cellData ? trueIcon : falseIcon} iconStyle={cellData ? trueIconStyle : falseIconStyle} />
    </span>
  );
}

BoolRenderer.propTypes = {
  cellData: PropTypes.any,
  /** Optionally the name of the true icon to display. */
  trueIcon: PropTypes.string,
  /** Optionally the style of the true icon to display. */
  trueIconStyle: PropTypes.string,
  /** Optionally the name of the false icon to display. */
  falseIcon: PropTypes.string,
  /** Optionally the style of the false icon to display. */
  falseIconStyle: PropTypes.string,
};

export default function(config) {
  return props => BoolRenderer({...config, ...props});
}
